import React from 'react';
import '../App.css';
import './HeroSection.css';
import { home3Jpg as homePicture2 } from '../images/assets';


function HeroSection() {
  return (
    <div className='hero-container'>
      <img src={homePicture2} alt={homePicture2} className='homeImage' />
      <h1>GLOBAL HEATING</h1>
      <p style={{color:'orangered'}}>What are you waiting for?</p>
    </div>
  );
}

export default HeroSection;
